import { getStorage, setStorage } from 'js/storage';

export default class Toaster {
    DEFAULT_CONFIG = {
        storageName: 'viaBovag_toaster',
        baseClassName: 'toaster',
        storageSelector: 'toaster',
        invalidHtml: /<(?!(\/?(em|strong))).+?>/
    };

    constructor() {
        this.config = { ...this.DEFAULT_CONFIG };
    }

    init() {
        this.bindListeners();
    }

    bindListeners() {
        this.closeButton.addEventListener('click', () => {
            this.saveToasterHideSetting();
            this.hideToaster();
        });
        if (this.image) {
            this.image.addEventListener('load', () => {
                this.node.classList.add(`${this.config.baseClassName}--active`);
            });
        } else {
            this.node.classList.add(`${this.config.baseClassName}--active`);
        }
    }

    /**
     * When use want's to hide the message, remember it.
     */
    saveToasterHideSetting() {
        this.toasterStorage.push(this.toasterParams.id);
        setStorage(this.config.storageSelector, this.toasterStorage);
    }

    /**
     *
     * @param {{
     *          id: string,
     *          imageSrc?: string,
     *          text: string,
     *          buttonText?: string,
     *          buttonHref?: string,
     *          buttonTarget?: string
     *        }} params
     */
    showToaster(params) {
        this.toasterParams = { ...params };
        if (!this.isValidConfig()) {
            return;
        }

        const existingNode = document.querySelector(`.${this.config.baseClassName}`);
        if (existingNode) {
            existingNode.remove();
        }
        this.createHTML();

        this.init();
    }

    isValidConfig() {
        /** @type {string[]} */
        this.toasterStorage = getStorage(this.config.storageSelector) || [];

        /** Are the required fields filled in? */
        if (!this.toasterParams.id || !this.toasterParams.text) {
            return false;
        }

        /** Did the visitor discarded this toaster before? */
        if (this.toasterStorage.includes(this.toasterParams.id)) {
            return false;
        }

        /** Does this text contain html not allowed? */
        if (this.config.invalidHtml.test(this.toasterParams.text)) {
            return false;
        }

        return true;
    }

    /**
     * @param {string} [imageSrc]
     * @param {string} text
     * @param {string} [buttonText]
     * @param {string} [buttonHref]
     * @param {string} [buttonTarget]
     */
    createHTML() {
        this.node = document.createElement('div');
        this.node.className = this.config.baseClassName;

        const wrapper = document.createElement('div');
        wrapper.className = `${this.config.baseClassName}__wrapper`;

        if (this.toasterParams.imageSrc) {
            this.image = document.createElement('img');
            this.image.className = `${this.config.baseClassName}__image`;
            this.image.src = this.toasterParams.imageSrc;
            this.image.alt = '';
        } else {
            this.image = null;
        }

        const paragraph = document.createElement('p');
        paragraph.className = `${this.config.baseClassName}__text`;
        paragraph.innerHTML = this.toasterParams.text;

        let button;
        if (this.toasterParams.buttonHref && this.toasterParams.buttonText) {
            button = document.createElement('a');
            button.href = this.toasterParams.buttonHref;
            button.innerHTML = this.toasterParams.buttonText;
            button.target = this.toasterParams.buttonTarget || '_blank';
            button.className = `button button-primary ${this.config.baseClassName}__button`;
        }

        this.closeButton = document.createElement('button');
        this.closeButton.className = `${this.config.baseClassName}__close`;
        this.closeButton.innerHTML = '✖';

        wrapper.append(this.image || '', paragraph, button || '');
        this.node.append(wrapper, this.closeButton);
        document.body.append(this.node);
    }

    /**
     *
     * Hides the toaster. After animation is done (css) it is removed
     */
    hideToaster() {
        this.node.classList.remove(`${this.config.baseClassName}--active`);
        setTimeout(() => {
            this.node.remove();
        }, 500);
    }
}
